module.exports = __webpack_public_path__ + "media/site_templates/www.gascooktopinstallation.com.au/images/about_us-f2a2f04d86a208d85f71116e1b47d58b.jpg";